
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";

export const useCheckOut = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async (bookingId: string) => {
      console.log('Checking out from booking:', bookingId);
      
      // Update the booking status to 'completed' and set check-out timestamp
      // The checked_out_at timestamp will trigger the penalty check via database trigger
      const { data, error } = await supabase
        .from('bookings')
        .update({ 
          status: 'completed',
          checked_out_at: new Date().toISOString(),
          updated_at: new Date().toISOString()
        })
        .eq('id', bookingId)
        .select()
        .single();

      if (error) {
        console.error('Check-out error:', error);
        throw new Error(error.message);
      }

      console.log('Check-out successful, updated booking:', data);
      console.log('Penalty check will be automatically triggered by database trigger if applicable');
      return data;
    },
    onSuccess: (data) => {
      console.log('Check-out mutation successful:', data);
      // Invalidate relevant queries to refresh the UI
      queryClient.invalidateQueries({ queryKey: ['bookings'] });
      queryClient.invalidateQueries({ queryKey: ['booking', data.id] }); // Invalidate specific booking query
      queryClient.invalidateQueries({ queryKey: ['provider-booking-detail'] }); // Invalidate all provider booking detail queries
      queryClient.invalidateQueries({ queryKey: ['provider-bookings'] });
      queryClient.invalidateQueries({ queryKey: ['penalties-log'] }); // Refresh penalties log in case penalty was applied
      
      toast({
        title: "Checked Out",
        description: "You have successfully checked out of your session.",
      });
    },
    onError: (error) => {
      console.error('Check-out failed:', error);
      toast({
        title: "Check-out Failed",
        description: `Failed to check out: ${error?.message || 'Unknown error'}`,
        variant: "destructive",
      });
    },
  });
};
